// extracted by mini-css-extract-plugin
export default {"container":"priceBreakdown_container__xG7kf","totalPrice":"priceBreakdown_totalPrice__O98en"};